export default __webpack_public_path__ + "static/media/content-bar.8975dcd0.png";